import Cookies from "js-cookie";
import { TbRefresh } from "react-icons/tb";
import { CircularProgress } from "@mui/material";
import noDataFound from "src/assets/no-data.png";
import { MdArrowBackIosNew } from "react-icons/md";
import { useApiWithAxios } from "src/hooks/useApi";
import CONSTANTS from "src/components/services/api";
import CustomBadge from "src/components/atoms/Badge";
import ChatCard from "src/components/molecules/ChatCard";
import CustomTab from "src/components/molecules/CustomTab";
import React, { useContext, useEffect, useState } from "react";
import {
  AdminDashboardContext,
  MyContext,
} from "src/components/Context/MyContext";
import StandardSearch from "src/components/atoms/inputfields/StandardSearch";
import loaderAnimation from "src/assets/loaderAnimation.gif";
import { Box, Modal } from "@mui/material";
import { toast, Bounce } from "react-toastify";

const CoachList = ({ onBack, bearerToken }) => {
  const limit = 5;
  const selectedUserId = Cookies.get("selected_user_id");
  const roleId = Cookies.get("roleId");
  const { selectedCoach, newMessageOn, setNewMessageOn } = useContext(
    AdminDashboardContext
  );
  const { socket, userId } = useContext(MyContext);
  const [query, setQuery] = useState("");

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "1px solid #F0F0F0",
    borderRadius: "8px",
    outline: "none",
    maxWidth: "100%",
    maxHeight: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // height: "100%",
    // width: "100%",
  };

  const [status, setStatus] = useState(1);
  const [pageNo, setPageNum] = useState(1);
  const [unread, setUnread] = useState(0);
  const [showLoader, setShowLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isExiting, setIsExiting] = useState(false);
  const [liveAndGrace, setLiveAndGrace] = useState(null);
  const [completedData, setCompletedData] = useState([]);
  const [ratingPendingBox, setRatingPendingBox] = useState(false);
  const [ratingCardData, setRatingCardData] = useState(null);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const { setSelectedChat } = useContext(MyContext);

  const handleSearchChange = (e) => {
    setQuery(e.target.value);
    setPageNum(1);
  };

  const handleTabChange = (val) => {
    setShowLoader(true);
    if (val < 2) {
      setStatus(val + 1);
      setPageNum(1);
      setUnread(0);
    }
    setTimeout(() => {
      setShowLoader(false);
    }, 100);
  };

  const handleUnreadClick = () => {
    setShowLoader(true);
    setPageNum(1);
    setUnread(1);
    setRefresh((prev) => !prev);
    setTimeout(() => {
      setShowLoader(false);
    }, 100);
  };

  const handleRefreshClick = () => {
    setShowLoader(true);
    setPageNum(1);
    setUnread(0);
    setRefresh((prev) => !prev);
    setTimeout(() => {
      setShowLoader(false);
    }, 100);
  };

  const handleBack = () => {
    setIsExiting(true);
  };

  // before use : `${CONSTANTS.API_BASE}/coachenrollmentschecks_production?coach_id=${userId}&limit=${limit}&pageNo=${pageNo}&status=${status}&keywords=${query}`,

  // const { data, error, loading } = useApiWithAxios(
  //   `${CONSTANTS.API_BASE}/coachenrollmentschecks_web?coach_id=${
  //     userId == "1" ? selectedUserId : userId
  //   }&limit=${limit}&pageNo=${pageNo}&status=${status}&keywords=${query}`,
  //   "GET",
  //   null,
  //   {
  //     headers: {
  //       Authorization: bearerToken ? bearerToken : CONSTANTS.BearerToken,
  //     },
  //   },
  //   [status, pageNo, query, newMessageOn, refresh]
  // );

  useEffect(() => {
    try {
      const payload = {
        coach_id:
          roleId == "1" || roleId == "6" || roleId == "7"
            ? selectedUserId
            : userId,
        limit: limit,
        pageNo: pageNo,
        keywords: query,
        status: status,
        unread: unread ? 1 : 0,
      };
      socket.emit("get-enrollment-coach", payload);
      socket.on("get-enrollment-coach-response", (response) => {
        const { error = null } = response;
        if (error) {
          setIsLoading(false);
          toast.error(error?.message || "Error occure in load more data", {
            position: "top-center",
            autoClose: 1000,
            transition: Bounce,
          });
          return;
        };
        setData(response);
      });
    } catch (error) {
      console.log("Error in socket connection", error);
    }
    return () => {
      socket.off("get-enrollment-coach-response");
    };
  }, [status, pageNo, query, newMessageOn, refresh, unread]);

  function existMessage(arr01, arr02) {
    const isAllExist = arr02.every((item2) =>
      arr01.some((item1) => item1._id === item2._id)
    );
    return isAllExist;
  }

  useEffect(() => {
    if (data) {
      setIsLoading(false);
      if (pageNo === 1) {
        if (status === 1) {
          setLiveAndGrace(data.data);
        } else if (status === 2) {
          setCompletedData(data.data);
        }
      } else {
        if (status === 1) {
          const isAllExist = existMessage(liveAndGrace, data.data);
          if (!isAllExist) {
            setLiveAndGrace((prev) => [...prev, ...data.data]);
          }
        } else if (status === 2) {
          const isAllExist = existMessage(completedData, data.data);
          if (!isAllExist) {
            setCompletedData((prev) => [...prev, ...data.data]);
          }
        }
      }
    }
  }, [data]);

  useEffect(() => {
    if (isExiting) {
      const timer = setTimeout(() => {
        onBack();
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [isExiting, onBack]);

  const loadMore = () => {
    setIsLoading(true);
    setPageNum((prev) => prev + 1);
  };

  const TabCardList = (list) => {
    if (showLoader) {
      return (
        <div className="flex justify-center h-[55vh] items-center">
          <img src={loaderAnimation} alt="loader" />
        </div>
      );
    }

    if (showLoader == false) {
      if (list && list?.length === 0) {
        return (
          <div className="flex flex-col justify-center items-center h-[550px] text-gray-500">
            <img src={noDataFound} alt="" />
            <h1 className="font-bold text-[#475569] text-[20px] text-center">
              No results found
            </h1>
            <p className="text-[#76767CCC] font-normal text-[12px] md:w-[250px] w-[200px] text-center mt-3">
              We couldn’t find what you are searched for. Try searching again
            </p>
          </div>
        );
      }
    }

    return (
      <>
        {ratingPendingBox && showRatingBox()}
        {list?.map((client, i) => (
          <ChatCard
            key={i}
            data={client}
            setRatingPendingBox={setRatingPendingBox}
            setRatingCardData={setRatingCardData}
          />
        ))}
        {list?.length < data?.total && (
          <div className="flex justify-center items-center">
            <button
              className="bg-white px-10 py-1 flex items-center justify-center rounded-md border-[2px] border-[#FBF712]  shadow-amber-200 mt-1 text-[12px] font-medium hover:bg-[#fbf659c1] transition-colors duration-200 hover:text-black"
              onClick={loadMore}
              disabled={isLoading}
            >
              {isLoading ? (
                <CircularProgress className="!h-7 !w-7 !text-black" />
              ) : (
                "Load more"
              )}
            </button>
          </div>
        )}
      </>
    );
  };

  function showRatingBox() {
    return (
      <Modal
        open={ratingPendingBox}
        onClose={() => setRatingPendingBox(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        <Box sx={style}>
          <div className="absolute top-[50%] border bg-white p-3 z-50 w-[325px] left-12 h-[125px]">
            <div>
              <h3 className="font-semibold">Rating Pending From User</h3>
            </div>
            <div className="flex justify-end mt-12">
              <button
                className="font-medium"
                onClick={() => setRatingPendingBox(false)}
              >
                ok
              </button>
              <button
                className="text-sm pl-12 font-medium"
                onClick={() => {
                  setSelectedChat(ratingCardData);
                  setNewMessageOn(!newMessageOn);
                  localStorage.setItem(
                    "showChat",
                    JSON.stringify(ratingCardData)
                  );
                  localStorage.setItem("my-message", JSON.stringify([]));
                  setRatingPendingBox(false);
                }}
              >
                VIEW CHAT
              </button>
            </div>
          </div>
        </Box>
      </Modal>
    );
  }

  const tabData = [
    {
      label: (
        <CustomBadge
          badgeContent={`${data?.totalMessage?.live_total}`}
          label="Live & Grace"
        />
      ),
      content: (
        <div className={`client-list ${isExiting ? "slide-out" : ""}`}>
          {TabCardList(liveAndGrace ? liveAndGrace : [])}
        </div>
      ),
    },
    {
      label: (
        <CustomBadge
          badgeContent={`${data?.totalMessage?.complete_total}`}
          label="Completed"
        />
      ),
      content: (
        <div className={`client-list ${isExiting ? "slide-out" : ""}`}>
          {TabCardList(completedData)}
        </div>
      ),
    },
    {
      label: "Unread",
    },
    {
      label: <TbRefresh size={22} style={{ transform: "rotate(180deg)" }} />,
    },
  ];
  return (
    <div className="!mt-0 ">
      {(roleId == "1" || roleId == "6" || roleId == "7") && selectedCoach ? (
        <div
          className={`client-list   ${isExiting ? "slide-out" : ""
            } text-[#3497F9] flex items-center space-x-1 cursor-pointer mb-3`}
          onClick={handleBack}
        >
          <MdArrowBackIosNew size={15} />
          <span className=" font-medium text-xs">Back</span>
        </div>
      ) : null}
      <StandardSearch
        placeholder={`${status === 1
          ? "Search Live & Grace clients..."
          : "Search completed clients..."
          }`}
        onChange={handleSearchChange}
        value={query}
      />
      <CustomTab
        tabs={tabData}
        initialIndex={0}
        changeTab={handleTabChange}
        onUnreadClick={handleUnreadClick}
        onRefreshClick={handleRefreshClick}
        refresh={refresh}
        setRefresh={setRefresh}
      />
    </div>
  );
};

export default CoachList;

